export default {
  install: function (Vue) {
    Vue.filter('formatIncome', val => {
      if (!val) return '0k'
      if (val % 1000 === 0) {
        return val / 1000 + 'k'
      }
      return (val / 1000).toFixed(1) + 'k'
    })
    Vue.filter('formatRegion', (val = '') => {
      return val.split(',').slice(-2).join('')
    })
  },
}
